import "./DateInputTimeSeparate.scss";
import moment from "moment";
export default {
  name: "DateInputTimeSeparate",
  data: () => ({
    dateModel: "",
    menuModel: false,
    formatedDate: "",
    timeModel: ""
  }),
  mounted() {
    this.initializeDateModels();
  },
  methods: {
    updateValue: function(value) {
      value = value.trim();
      const momentValue = this.useUTC ? moment.utc(value) : moment(value);
      this.formatedDate = momentValue?.format(this.format) ?? "";
      let momentObj = moment(value);
      if (this.overwriteTime) {
        let { [0]: hour, [1]: minute } = this.overwriteTime.split(":");
        momentObj.set({ hour, minute });
      }
      this.$emit("input", value ? momentObj.toISOString() : "");
    },
    initializeDateModels() {
      this.dateModel = moment(this.value).format("YYYY-MM-DD");
      this.timeModel = moment(this.value).format("HH:mm");
      this.formatedDate = moment(this.value).format(this.format);
      if (this.dateModel.includes("Invalid")) {
        this.dateModel = "";
        this.timeModel = "";
        this.formatedDate = "";
      }
    },
    fillDefault() {
      if (!this.dateModel) this.dateModel = moment().format("YYYY-MM-DD");
      if (!this.timeModel) {
        if (this.dateTime) {
          // default time if time-picker is active
          this.timeModel = "12:00";
        } else {
          // no time-picker. use 03:00 to prevent unintentional 'day before selection' on first input (timezone hour shifting)
          this.timeModel = "03:00";
        }
      }
    }
  },
  watch: {
    value: function() {
      this.initializeDateModels();
    }
  },
  props: {
    value: {
      //type: String, comment to suppress warning
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: "DD.MM.YYYY"
    },
    dateTime: {
      type: Boolean,
      default: false
    },
    overwriteTime: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    appendIcon: {
      type: String,
      default: null
    },
    useUTC: {
      type: Boolean,
      default: true
    },
    error: {},
    allowedDatesFunc: {
      default: null
    }
  }
};
